module.exports = __webpack_public_path__ + "static/media/white.3f87c949.png";